import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import { IconComponent as Icon } from 'components/icon';

import logo from 'static/logos/main-logo.svg';
import styles from './main-nav-component.styles.scss';


export class MainNavComponent extends React.Component {
  static propTypes = {
    display: PropTypes.oneOf(['row', 'column']),
    className: PropTypes.string,
    onNavigate: PropTypes.func,
  }

  static defaultProps = {
    display: 'row',
    className: '',
    onNavigate: () => {}
  }

  render() {
    const { display } = this.props;
    const className = classnames(
      styles.MainNav,
      this.props.className,
      styles[`MainNav--${display}`]
    );

    return (
      <ul className={className}>
        { this.renderNavItem('Seminare', '/lectures') }
        { this.renderNavItem('Therapie', '/therapies') }
        { this.renderLogo('row') }
        { this.renderNavItem('Konsultation', '/consultation') }
        { this.renderNavItem('Kontakt', '/contact') }
      </ul>
    );
  }

  // className has to be set on the <Link /> element, in order to
  // overwrite the useragent style sheets.
  renderNavItem(label, to, className='') {
    className = classnames(styles.MenuItem, className);

    return (
      <li className={className}>
        <NavLink to={to} onClick={this.onClick} activeClassName={styles.Active}>
          { label }
        </NavLink>
      </li>
    );
  }

  renderLogo(where) {
    const shouldRender = this.props.display === where;

    if (!shouldRender) { return null; }

    const icon = <Icon src={logo} className={styles.Icon} />
    return this.renderNavItem(icon, '/', styles[`MenuItem--${where}`]);
  }

  onClick = (event) => {
    event.stopPropagation();

    this.props.onNavigate(event);
  }
}



// WEBPACK FOOTER //
// ./src/components/main-nav/main-nav.component.jsx